<div class="row justify-content-center mt-5">
    <div class="col-10">
        <h1>Permission denied</h1>
        <div class="d-flex align-items-center mt-3">
            <ca-icon name="warning" size="s" class="ca-color-icon-warning me-3" [removeSVGAttributes]="['stroke']"></ca-icon>
            <div class="text">
                You don't seem to have the permission to access this page. <br />
                Please contact your administrator to give you respective permissions.
            </div>
        </div>
    </div>
</div>
